import request from '@/utils/request'

// 查询标书评分自测列表
export function listSelfassessment(query) {
  return request({
    url: '/screen/intelligentinspection/selfassessment/list',
    method: 'get',
    params: query
  })
}

// 查询标书评分自测详细
export function getSelfassessment(pid) {
  return request({
    url: '/screen/intelligentinspection/selfassessment/detail/' + pid,
    method: 'get'
  })
}

// 新增标书评分自测
export function addSelfassessment(data) {
  return request({
    url: '/screen/intelligentinspection/selfassessment/add',
    method: 'post',
    data: data
  })
}

// 修改标书评分自测
export function updateSelfassessment(data) {
  return request({
    url: '/screen/intelligentinspection/selfassessment/edit',
    method: 'post',
    data: data
  })
}

// 删除标书评分自测
export function delSelfassessment(pid) {
  return request({
    url: '/screen/intelligentinspection/selfassessment/delete/' + pid,
    method: 'get'
  })
}
